import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import AssessmentWizard from './components/AssessmentWizard';
import ClientHeader from './components/ClientHeader';
import ClientDashboard from './pages/ClientDashboard';
import ClientLogin from './pages/ClientLogin';
import ProfilePage from './pages/ProfilePage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminAssessments from './pages/admin/AdminAssessments';
import AdminExecutions from './pages/admin/AdminExecutions';
import AdminSettings from './pages/admin/AdminSettings';
import AdminDataTables from './pages/admin/AdminDataTables';
import AgentLayout from './pages/agent/AgentLayout';
import AgentDashboard from './pages/agent/AgentDashboard';
import AgentExecutions from './pages/agent/AgentExecutions';
import AgentCustomers from './pages/agent/AgentCustomers';
import InitiateAssessmentFlow from './components/InitiateAssessmentFlow';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ClientHeader />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/assessment" element={<AssessmentWizard />} />
        <Route path="/assessment/:assessmentId" element={<AssessmentWizard />} />
        <Route path="/login" element={<ClientLogin />} />
        <Route path="/dashboard" element={<ClientDashboard />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="assessments" element={<AdminAssessments />} />
          <Route path="executions" element={<AdminExecutions />} />
          <Route path="data-tables" element={<AdminDataTables />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="initiate" element={<InitiateAssessmentFlow role="admin" />} />
        </Route>
        <Route path="/agent" element={<AgentLayout />}>
          <Route index element={<AgentDashboard />} />
          <Route path="executions" element={<AgentExecutions />} />
          <Route path="customers" element={<AgentCustomers />} />
          <Route path="initiate" element={<InitiateAssessmentFlow role="agent" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
